export default __webpack_public_path__ + "static/media/product-default.f13243bf.jpg";